import { render, staticRenderFns } from "./ClickToCallComponent.vue?vue&type=template&id=0e8b2b60&scoped=true"
import script from "./ClickToCallComponent.vue?vue&type=script&lang=js"
export * from "./ClickToCallComponent.vue?vue&type=script&lang=js"
import "./ClickToCallComponent.vue?vue&type=style&index=0&id=0e8b2b60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8b2b60",
  null
  
)

export default component.exports